export default __webpack_public_path__ + "static/media/a023-short1.93b2b801.jpg";